<div class="modal-header">
  <div class="d-flex modal-wizard">
    <h6 class="modal-title whitespacenowrap">Import Prospects</h6>
    <ul class="wizardstyle2 clearfix">
      <li [ngClass]="{'success' : menu.SelectedProperties <= activeMenu ,'inactive': menu.SelectedProperties > activeMenu}" (click)="setMenuID(menu.SelectedProperties)">
        <div class="blueborder-circle">
          <span></span>
        </div>
        <p>Select Properties</p>
      </li>
      <li [ngClass]="{'success' : menu.ImportProspects <= activeMenu ,'inactive': menu.ImportProspects > activeMenu}" (click)="setMenuID(menu.ImportProspects)">
        <div class="blueborder-circle">
          <span></span>
        </div>
        <p>Import Prospects</p>
      </li>
      <li [ngClass]="{'success' : menu.Preview <= activeMenu ,'inactive': menu.Preview > activeMenu}" (click)="setMenuID(menu.Preview)">
        <div class="blueborder-circle">
          <span></span>
        </div>
        <p>Preview</p>
      </li>
    </ul>
    <button type="button" class="close pull-right" aria-label="Close" (click)="onClose();">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
</div>
<div class="modal-body padding30  advanced-search-div-bg text-center" id="divimportprospects">
  <div>
    <div class="search-div advanced-search-div clearfix search-div-02">
      <div class="advanced-search-inner d-flex" id="advanced-search">
        <div class="form-group bigdiv location-auto-complete" style="width:20%" *ngIf="menu.SelectedProperties == activeMenu">
          <i aria-hidden="true" class="fa fa-search icon" style="color: #ccc;"></i>
          <input class="form-control" type="text" placeholder="Property, State, City, Status" [(ngModel)]="searchNote" id="property-import-search">
        </div>
        <div class="form-group bigdiv location-auto-complete" style="width:70%" *ngIf="menu.SelectedProperties != activeMenu">
          <i aria-hidden="true" class="fa fa-search icon" style="color: #ccc;"></i>
          <input class="form-control" type="text" placeholder="Prospect" [(ngModel)]="searchNote" id="prospect-import-search">
        </div>
        <div class='form-group smalldiv' *ngIf="menu.SelectedProperties == activeMenu">
          <div class="select-dropdown right-border multiselectdesign mutidesignnoborder">
            <mat-form-field>
               <mat-select placeholder="Select Broker" [(ngModel)]="selectedBrokers" multiple class="materialoption">
                @if (selectedBrokers?.length > 1) {
                  <mat-select-trigger  >
                    <span>{{ selectedBrokers?.length }} Brokers selected</span>
                  </mat-select-trigger>
                }
                <mat-option *ngIf="inputBroker.length === 0" [disabled]="true" class="matoption-nodata">
                  Nothing found
                </mat-option>
                @for (broker of inputBroker; track brokers) {
                <mat-option [value]="broker.id" class="materialoption multi-dropdown-item">{{broker.name}}</mat-option>
                }
              </mat-select>
            </mat-form-field>
            <!--<angular2-multiselect [data]="inputBroker" [(ngModel)]="selectedBrokers" [settings]="defaultBrokerSettings"></angular2-multiselect>-->
          </div>
        </div>
        <div class='form-group smalldiv' *ngIf="menu.SelectedProperties == activeMenu">
          <div class="select-dropdown right-border multiselectdesign mutidesignnoborder">
            <mat-form-field>
               <mat-select placeholder="Select Property Type" [(ngModel)]="selectedAssetTypes" multiple>
                @if (selectedAssetTypes?.length > 1) {
                  <mat-select-trigger  >
                    <span>{{ selectedAssetTypes?.length }} Property Types selected</span>
                  </mat-select-trigger>
                }
                <mat-option *ngIf="inputAssetTypes.length === 0" [disabled]="true" class="matoption-nodata">
                  Nothing found
                </mat-option>
                @for (assetType of inputAssetTypes; track assetType) {
                <mat-option [value]="assetType.id" class="multi-dropdown-item">{{assetType.name}}</mat-option>
                }
              </mat-select>
            </mat-form-field>
            <!--<angular2-multiselect [data]="inputAssetTypes" [(ngModel)]="selectedAssetTypes" (ngModelChange)="bindSubCategoroes($event);" [settings]="defaultTypeSettings"></angular2-multiselect>-->
          </div>
        </div>
        <div class='form-group smalldiv' *ngIf="menu.SelectedProperties == activeMenu">
          <div class="select-dropdown right-border multiselectdesign mutidesignnoborder">
            <mat-form-field>
               <mat-select placeholder="Select Subcategory" [(ngModel)]="selectedSubCategories" multiple>
                @if (selectedSubCategories?.length > 1) {
                  <mat-select-trigger  >
                    <span>{{ selectedSubCategories?.length }} Subcategories selected</span>
                  </mat-select-trigger>
                }
                <mat-option *ngIf="inputSubCategory.length === 0" [disabled]="true" class="matoption-nodata">
                  Nothing found
                </mat-option>
                @for (subcategory of inputSubCategory; track $index) {
                <mat-option [value]="subcategory.id" class="multi-dropdown-item">{{subcategory.name}}</mat-option>
                }
              </mat-select>
            </mat-form-field>
            <!--<angular2-multiselect [data]="inputSubCategory" [(ngModel)]="selectedSubCategories" [settings]="defaultCategorySettings"></angular2-multiselect>-->
          </div>
        </div>
        <div class="d-felx">
          <button class="searchbtn import-prospect-search-btn margin-left-10" (click)="onPropertySearch()">Search</button>
          <a href="javascript:void(0);" *ngIf="((selectedBrokers!=null&&selectedBrokers.length>0)||(selectedAssetTypes!=null&&selectedAssetTypes.length>0)||(selectedSubCategories!=null&&selectedSubCategories.length>0)||(searchNote!=null&&searchNote!=''))&&menu.SelectedProperties == activeMenu" tooltip="Clear Search" placement="left" class="btn-icon01" (click)="onResetClick()"><i class="icon-reset" aria-hidden="true"></i>Reset</a>
          <a href="javascript:void(0);" *ngIf="searchNote!=null&&searchNote!=''&&menu.ImportProspects == activeMenu" tooltip="Clear Search" placement="left" class="btn-icon01" (click)="onResetClick()"><i class="icon-reset" aria-hidden="true"></i>Reset</a>
          <a href="javascript:void(0);" *ngIf="searchNote!=null&&searchNote!=''&&menu.Preview == activeMenu" tooltip="Clear Search" placement="left" class="btn-icon01" (click)="onResetClick()"><i class="icon-reset" aria-hidden="true"></i>Reset</a>
        </div>
      </div>
    </div>
   
    <div id="div-selected-properties">

      <div class="d-flex filter-header-rt floatinghead clearfix margin-bottom-5">
        <div class="leftside d-flex property-tags margin-bottom-15" *ngIf="activeMenu==menu.SelectedProperties&&selectedRows!=null && selectedRows.length>0">
          <label class="whitespacenowrap margin-right-5">Selected Properties: </label>
          <div class="margin-left-5 text-left">
            <span *ngFor="let selectedData of selectedRows; let j = index">
              <span class="Off-Market margin-right-5 margin-bottom-5" *ngIf="j<5||IsSelectedPropertyOpened">
                {{ selectedData.PropertyName}}
                <a href="javascript:void(0);" (click)="onSelectedPropertyRemove(selectedData.Id)">
                  <i class="icofont icofont-close"></i>
                </a>
              </span>
            </span>
            <span *ngIf="selectedRows.length>selectedCheckboxDataLimit&&!IsSelectedPropertyOpened" class="Off-Market margin-right-5 margin-bottom-5">
              <a href="javascript:void(0);" (click)="onViewAllProperties()">
                {{'+' + (selectedRows.length-selectedCheckboxDataLimit) }} More
              </a>
            </span>
            <span *ngIf="selectedRows.length>0&&IsSelectedPropertyOpened" class="Off-Market margin-right-5 margin-bottom-5">
              <a href="javascript:void(0);" (click)="hideAllProperties()">
                Show Less
              </a>
            </span>
          </div>
        </div>
        <div class="leftside d-flex property-tags margin-bottom-15" *ngIf="activeMenu==menu.ImportProspects&&selectedProspects!=null&&selectedProspects.length>0">
          <label class="whitespacenowrap margin-right-5">
            Selected Prospects:
          </label>
          <div class="margin-left-5 text-left">
            <span *ngFor="let prospects of selectedProspects; let j = index">
              <span class="Off-Market margin-right-5 margin-bottom-5" *ngIf="j<5||IsSelectedProspectOpened">
                {{ prospects.ProspectName }}
                <a href="javascript:void(0);" (click)="onSelectedProspectsRemove(prospects.Id)"><i class="icofont icofont-close"></i></a>
              </span>
            </span>
            <span *ngIf="selectedProspects.length>selectedCheckboxDataLimit&&!IsSelectedProspectOpened" class="Off-Market margin-right-5 margin-bottom-5">
              <a href="javascript:void(0);" (click)="onViewAllProspects()">

                {{'+' + (selectedProspects.length-selectedCheckboxDataLimit) }} More
              </a>
            </span>
            <span *ngIf="selectedProspects.length>0&&IsSelectedProspectOpened" class="Off-Market margin-right-5 margin-bottom-5">
              <a href="javascript:void(0);" (click)="onHideProspects()">
                Show Less
              </a>
            </span>
          </div>
        </div>
        <!--<div class="leftside d-flex property-tags margin-bottom-15" *ngIf="activeMenu==menu.Preview&&selectedRows!=null&&selectedRows.length>0">
      <label class="whitespacenowrap margin-right-5">
        Selected Properties:
      </label>
      <div class="margin-left-5">
        <span *ngFor="let selectedData of selectedRows; let j = index">
          <span class="Off-Market margin-right-5 margin-bottom-5" *ngIf="j<5||IsSelectedPreviewOpened">{{ selectedData.PropertyName }}</span>
        </span>
        <span *ngIf="selectedRows.length>selectedCheckboxDataLimit&&!IsSelectedPreviewOpened" class="Off-Market margin-right-5 margin-bottom-5">
          <a href="javascript:void(0);" (click)="onViewAllPreview()">
            {{'+' + (selectedRows.length-selectedCheckboxDataLimit) }} More
          </a>
        </span>
        <span *ngIf="selectedRows.length>0&&IsSelectedPreviewOpened" class="Off-Market margin-right-5 margin-bottom-5">
          <a href="javascript:void(0);" (click)="onHidePreview()">
            Show Less
          </a>
        </span>
      </div>
    </div>-->
        <!--<div class="rightside d-flex ml-auto" *ngIf="activeMenu>menu.SelectedProperties">
      <div class="search-sec">
        <input class="form-control" type="text" [(ngModel)]="searchNote" (keyup)="onSearch($event.target.value)" placeholder="Search" id="import-search">
        <i aria-hidden="true" class="fa fa-search icon"></i>
      </div>
    </div>-->
      </div>
      <div *ngIf="activeMenu==menu.ImportProspects">
        <p class="selected-rows-count margin-bottom-10" *ngIf="selectedProspects?.length > 0 && hideselectionLinks">
          {{selectedProspects?.length}} row{{selectedProspects?.length == 1 ? '':'s'}} selected
          <a class="remove" tooltip="Remove Selection" href="javascript:void(0);" (click)="resetSelectedRows();"><i class="icofont icofont-close" aria-hidden="true"></i></a>
        </p>
        <p class="selected-rows-count margin-bottom-10" *ngIf="selectedProspects?.length > 0 && !hideselectionLinks">
          All {{selectedProspects?.length}} rows on this page are selected
          <a class="remove" tooltip="Remove Selection" href="javascript:void(0);" (click)="resetSelectedRows();"><i class="icofont icofont-close" aria-hidden="true"></i></a>
          <a href="javascript:void(0);" *ngIf="activeMenu==menu.ImportProspects" class="bluelink margin-left-10" (click)="selectOrUnSelectAllProspects(true,true)">Select all {{allProspectCount}} rows</a>
        </p>
      </div>
      <div class="row  margin-bottom-15" *ngIf="activeMenu==menu.SelectedProperties">
        <div class="col-md-8">
        </div>
        <div class="col-md-4">
          <div class="d-flex margin-bottom-15">
            <div class="ml-auto d-inline">
              <label class="custom-checkbox margin-right-15">
                <input type="checkbox" [(ngModel)]="IsArchived" *ngIf="activeMenu==menu.SelectedProperties" id="checkboxprivilageForSeller" (ngModelChange)="showArchivedProperties()">Show Archived
                <i></i>
              </label>
            </div>
          </div>
        </div>
      </div>
      <div class="table-responsive table-v-scroll table-fixed import-prospect-table" style="width: 100%">
        <table id="openro-data" class="table basictable row-border hover" datatable [dtOptions]="dtoptions">
          <thead>
            <tr>
              <th data-orderable="false" style="width:5px">
                <label class="custom-checkbox withoutlabel" *ngIf="activeMenu==menu.SelectedProperties">
                  <input type="checkbox" [(ngModel)]="selectAll" (change)="onSelectAll($event);" class="ng-pristine ng-valid ng-touched"><i></i>Select
                </label>
                <label class="custom-checkbox withoutlabel" *ngIf="activeMenu==menu.ImportProspects">
                  <input type="checkbox" [(ngModel)]="selectAllProspects" (change)="onSelectAllProspects($event);" class="ng-pristine ng-valid ng-touched"><i></i>Select
                </label>
                <label *ngIf="activeMenu==menu.Preview">
                  Remove
                </label>
              </th>
              <th [hidden]="activeMenu==menu.Preview" style="width:2px">

              </th>
              <th [hidden]="activeMenu!=menu.SelectedProperties">Property Name</th>
              <th [hidden]="activeMenu!=menu.SelectedProperties">State</th>
              <th [hidden]="activeMenu!=menu.SelectedProperties">City</th>
              <th [hidden]="activeMenu!=menu.SelectedProperties">Status</th>
              <th [hidden]="activeMenu!=menu.SelectedProperties" class="prospectCount">No. Of Prospects</th>
              <th [hidden]="activeMenu==menu.SelectedProperties" class="prospectId" style="min-width:200px">Prospects</th>
              <th [hidden]="activeMenu==menu.SelectedProperties" style="min-width:180px">Organization</th>
              <th [hidden]="activeMenu==menu.SelectedProperties" data-orderable="false">Properties / Notes</th>
              <th [hidden]="activeMenu!=menu.SelectedProperties" data-orderable="false">Brokers</th>
            </tr>
          </thead>
          <tbody>
            <ng-container *ngIf="activeMenu==menu.SelectedProperties">
              <tr *ngFor="let item of importProperties; let i = index">
                <td>
                  <label class="custom-checkbox withoutlabel">
                    <input type="checkbox" [(ngModel)]="item.IsSelected" (change)="onCheckboxChange($event,item.Id);" class="ng-pristine ng-valid ng-touched"><i></i>
                  </label>
                </td>
                <td></td>
                <td class="whitespacenowrap">
                  <p class="property-name">
                    <a target="_blank" href="#" routerLink="/viewproperty/{{item.Guid}}">
                      {{item.PropertyName}}<span class="Off-Market margin-left-5">{{IsArchived?'B+E Listing, Archived':'B+E Listing'}}</span>
                    </a>
                  </p>
                </td>
                <td class="whitespacenowrap">
                  <p>
                    {{item.State}}
                  </p>
                </td>
                <td class="whitespacenowrap">
                  <p>{{item.City}}</p>
                </td>
                <td class="whitespacenowrap">
                  <div style="display:table">
                    <p [ngClass]="{'redtextlabel':(item.Status === 'Closed' || item.Status === 'Sold'),'greentextlabel':item.Status === 'Available','orangetextlabel':item.Status === 'Under Contract','not-available':item.Status === 'Not Available','Off-Market':(item.Status === 'Off-Market'||item.Status === 'BOV'||item.Status === 'Pre-Marketing')}">{{ item.Status }}</p>
                    <p class="margin-top-10">{{item.SaleDate!=null?('Sale Date: '+ (item.SaleDate | date:'MM/dd/yyyy' )):''}}</p>
                  </div>
                </td>
                <td class="whitespacenowrap">
                  <p>{{item.ProspectCount}}</p>
                </td>
                <td class="whitespacenowrap tool-tip-break"><p placement="bottom" container="body" tooltip="{{item.Brokers? item.Brokers : '-'}}">{{item.Brokers ? _commonService.GetPropertyTypeWithCount(item.Brokers) : '-' }}</p></td>
              </tr>
            </ng-container>
            <ng-container *ngIf="activeMenu==menu.ImportProspects">
              <tr *ngFor="let item1 of importProspects; let r = index">
                <td>
                  <label class="custom-checkbox withoutlabel">
                    <input type="checkbox" [(ngModel)]="item1.IsSelected" (change)="onProspectsCheckboxChange($event,item1.Id);" class="ng-pristine ng-valid ng-touched"><i></i>
                  </label>
                </td>
                <td></td>
                <td class="whitespacenowrap">
                  <p>
                    <a href="javascript:void(0);" target="_blank" routerLink="/prospect-detail/" [queryParams]="{prospectId:item1.Id,prevroute:'Property Details',link:router.url}">
                      {{item1.ProspectName}}
                    </a>
                  </p>
                </td>
                <td class="whitespacenowrap">
                  <p>
                    {{item1.Company}}
                  </p>
                </td>
                <td>
                  <div class="d-flex">
                    <div class="margin-left-10" *ngIf="item1.IsShowCollapse">
                      <p class="d-flex">
                        <a class="btn-collapse" (click)="showFullNotes(item1)" *ngIf="!item1.IsShowFullNotes">
                          <i class="fa fa-angle-right" aria-hidden="true"></i>
                        </a>
                        <a class="btn-collapse" (click)="hideFullNotes(item1)" *ngIf="item1.IsShowFullNotes">
                          <i class="fa fa-angle-down" aria-hidden="true"></i>
                        </a>
                      </p>
                    </div>
                    <div *ngIf="!item1.IsShowFullNotes">
                      <p *ngFor="let note of item1.ProspectNotes; let j = index"><a target="_blank" href="#" routerLink="/viewproperty/{{note.PropertyGuid}}">{{ note.PropertyName }}</a>{{' - '+note.Notes}}</p>
                    </div>
                    <div class="import-prospect-notes" *ngIf="item1.IsShowFullNotes">
                      <p *ngFor="let note of item1.AllProspectNotes; let j = index"><a target="_blank" href="#" routerLink="/viewproperty/{{note.PropertyGuid}}">{{ note.PropertyName }}</a>{{' - '+note.Notes}}</p>
                    </div>
                  </div>
                </td>
              </tr>
            </ng-container>
            <ng-container *ngIf="activeMenu==menu.Preview">
              <tr *ngFor="let item1 of selectedProspectList; let r = index">
                <td>
                  <a class="remove" tooltip="Remove" href="javascript:void(0);" (click)="onPreviewRemove(item1.Id)"><i class="icofont icofont-close" aria-hidden="true"></i></a>
                </td>
                <td class="whitespacenowrap">
                  <p>
                    <a href="javascript:void(0);" target="_blank" routerLink="/prospect-detail/" [queryParams]="{prospectId:item1.Id,prevroute:'Property Details',link:router.url}">
                      {{item1.ProspectName}}
                    </a>
                  </p>
                </td>
                <td class="whitespacenowrap">
                  <p>
                    {{item1.Company}}
                  </p>
                </td>
                <td>
                  <div class="d-flex">
                    <div class="margin-left-10" *ngIf="item1.IsShowCollapse">
                      <p class="d-flex">
                        <a class="btn-collapse" (click)="showFullNotes(item1)" *ngIf="!item1.IsShowFullNotes">
                          <i class="fa fa-angle-right" aria-hidden="true"></i>
                        </a>
                        <a class="btn-collapse" (click)="hideFullNotes(item1)" *ngIf="item1.IsShowFullNotes">
                          <i class="fa fa-angle-down" aria-hidden="true"></i>
                        </a>
                      </p>
                    </div>
                    <div class="d-flex">
                      <div *ngIf="!item1.IsShowFullNotes">
                        <span *ngFor="let note of item1.ProspectNotes; let j = index"><p><a target="_blank" href="#" routerLink="/viewproperty/{{note.PropertyGuid}}">{{ note.PropertyName }}</a>{{' - '+note.Notes}}</p></span>
                      </div>
                      <div class="import-prospect-notes" *ngIf="item1.IsShowFullNotes">
                        <span *ngFor="let note of item1.AllProspectNotes; let j = index"><p><a target="_blank" href="#" routerLink="/viewproperty/{{note.PropertyGuid}}">{{ note.PropertyName }}</a>{{' - '+note.Notes}}</p></span>
                      </div>
                    </div>
                  </div>
                </td>
              </tr>
            </ng-container>
          </tbody>
          <tfoot>
            <tr *ngIf="activeMenu==menu.SelectedProperties&&importProperties?.length == 0&&!IsDataProcessing">
              <td colspan="8" class="odd no-data-available">
                <div class="nodata">
                  <i class="fa fa-exclamation-triangle icon"></i>
                  <p>No Data Available</p>
                </div>
              </td>
            </tr>
            <tr *ngIf="activeMenu==menu.ImportProspects&&importProspects?.length == 0&&!IsDataProcessing">
              <td colspan="5" class="odd no-data-available">
                <div class="nodata">
                  <i class="fa fa-exclamation-triangle icon"></i>
                  <p>No Data Available</p>
                </div>
              </td>
            </tr>
            <tr *ngIf="activeMenu==menu.Preview&&selectedProspectList?.length == 0&&!IsDataProcessing">
              <td colspan="5" class="odd no-data-available">
                <div class="nodata">
                  <i class="fa fa-exclamation-triangle icon"></i>
                  <p>No Data Available</p>
                </div>
              </td>
            </tr>
          </tfoot>
        </table>
      </div>

    </div>
  </div>
  <div class="text-right">
    <button type="button" class="btn btn-default btn-lg " (click)="onClose()">Cancel</button>
    <button class="btn btn-border btn-lg" *ngIf="activeMenu>menu.SelectedProperties" (click)="loadNewWidget(activeMenu,'Back')"> Back</button>
    <button class="btn btn-success btn-lg" *ngIf="activeMenu==menu.SelectedProperties" (click)="loadNewWidget(activeMenu,'Next')">Next</button>
    <button class="btn btn-success btn-lg" *ngIf="activeMenu==menu.ImportProspects" (click)="loadNewWidget(activeMenu,'PreviewandImport')">Preview and Import</button>
    <button class="btn btn-success btn-lg" *ngIf="activeMenu==menu.Preview" (click)="saveImportProspect()">Import Prospects</button>
  </div>
</div>
